<app-header></app-header>
    <section class="content-box">
        <div class="tab-content" id="myTabContent">
            <!--  market Position -->
            <div class="tab-pane fade show active" id="market">
                <div class="deta-tebal-box">
                    <div class=" hedar-bekada">  
                            <a  class="btn p-0 px-3 m-0" [routerLink]="['/badlaorder']">
                                <i class="fas fa-arrow-left"></i> Back 
                            </a>  
                            <a  class="btn p-0 px-3 m-0" (click)="downloadAsPDF()">
                                <i class="fas fa-download"></i> CSV  
                            </a>  
                            <h5 class="p-0 m-0 ml-2 d-flex white-sp ">Total PL : <span [ngClass]=" overAllResult > 0 ? 'buy-class' : 'sell-class'">{{overAllResult}}</span></h5>       
                    </div>
                    <div class="setin-boxs  defo-bx-man">
                        <div class="w-50 d-flex drop-dro-box">
                            <select class="form-control w-25" name="badlaType" [(ngModel)]="selectedBadla">
                                <option [value]="1">All</option>
                                <option *ngFor="let badlaIns of scriptFilter; let i = index;" value="{{badlaIns.badlRefId}}">{{badlaIns.reference}}</option>
                            </select>
                            <button type="button" class="btn but-boxa btn-primary" (click)="searchBadlaScript()">
                                Search
                            </button>
                        </div>
                  
                             
                        <div class="but-box-man">
                            <button type="button" class="btn but-boxa btn-danger" (click)="clearAllOpenModal()">
                                Delete All Badla
                            </button>
                        </div>              
                    </div>
                  
                    <div class="respo-scroll">
                        <table *ngIf="filterBadla" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="default-table-style m-1 my-3">
                            <thead>
                                <tr>
                                    <td>No</td>
                                    <td>Action</td>
                                    <td>Created Date</td>
                                    <td>Updated Date</td>
                                    <td>Description</td>
                                    <td>Balance</td>
                                </tr>
                            </thead>
                            <tbody >
                                <tr *ngFor="let badlaOrder of filterBadla; let i = index; let last = last;">
                                    <td class="text-center px-2 ">{{i + 1}}</td>
                                    <td class="text-center col-md-2">
                                        <button type="button" class="btn but-view btn-success" [routerLink]="['/order-detail/',badlaOrder['badlRefId']]" >
                                            View
                                        </button>
                                    </td>  
                                    <td class="text-left col-md-3">{{badlaOrder['createdAt'] | date : 'dd/MM/yyyy h:mm a'}}
                                    <td class="text-left col-md-3">{{badlaOrder['plDetail']['createdAt'] | date : 'dd/MM/yyyy h:mm a'}}
                                    </td>
                                    <td class="text-left col-md-3">{{badlaOrder['reference']}}
                                        [{{badlaOrder['settingName']}}]
                                    </td>
                                    
                                    <td class="text-left col-md-4 ">Closing Balance : <span [ngClass]="badlaOrder['plDetail']['CalculateBalance'] >= 0 ? 'buy-class float-right' : ' sell-class float-right'">{{(badlaOrder['plDetail'])?badlaOrder['plDetail']['CalculateBalance']:0}}</span></td>
                                                                   
                                </tr>
                                <!-- <tr>
                                    <td class="text-left col-md-3">{{badlaOrder['comexDetail'][0]['original_exchange']}} - {{badlaOrder['comexDetail'][0]['name']}} {{badlaOrder['comexDetail'][0]['expiry']}}</td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['comexType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['comexType'] | titlecase}} - {{badlaOrder['comexQty']}} - {{badlaOrder['comexPrice']}}</span>
                                    </td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['endComexType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['endComexType'] | titlecase}} - {{badlaOrder['comexQty']}} - {{badlaOrder['endComexPrice']}}</span> 
                                    </td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['comexResult'] > 0 ? 'buy-class' : 'sell-class' ">{{badlaOrder['comexResult']}}</span></td>
                                </tr>
                                <tr>
                                    <td class="text-left col-md-3">{{badlaOrder['mcxDetail'][0]['original_exchange']}} - {{badlaOrder['mcxDetail'][0]['name']}} {{badlaOrder['mcxDetail'][0]['expiry']}}
                                    </td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['mcxType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['mcxType'] | titlecase}} - {{badlaOrder['mcxQty']}} - {{badlaOrder['mcxPrice']}}</span></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['endMcxType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['endMcxType'] | titlecase}} - {{badlaOrder['mcxQty']}} - {{badlaOrder['endMcxPrice']}}</span></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['mcxResult'] > 0 ? 'buy-class' : 'sell-class' ">{{badlaOrder['mcxResult']}}</span></td> 
                                </tr>
                                <tr>
                                    <td class="text-left col-md-3">{{badlaOrder['dgcxDetail'][0]['original_exchange']}} - {{badlaOrder['dgcxDetail'][0]['name']}} {{badlaOrder['dgcxDetail'][0]['expiry']}}
                                    </td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['dgcxType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['dgcxType'] | titlecase}} - {{badlaOrder['dgcxQty']}} - {{badlaOrder['dgcxPrice']}}</span></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['endDgcxType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['endDgcxType'] | titlecase}} -  {{badlaOrder['dgcxQty']}} - {{badlaOrder['endDgcxPrice']}}</span></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['dgcxResult'] > 0 ? 'buy-class' : 'sell-class'">{{badlaOrder['dgcxResult']}}</span></td>
                                </tr>
                                <tr>
                                    <td class="text-center col-md-3"></td>
                                    <td class="text-center col-md-3"></td>
                                    <td class="text-center col-md-3"></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['totalResult'] > 0 ? 'buy-class' : 'sell-class'">{{badlaOrder['totalResult']}}</span></td>
                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                   

                </div>
            </div>
            <!-- badle settig -->
            <div class="tab-pane fade" id="badle">
               1 
            </div>
            <!--  settig Report -->
            <div class="tab-pane fade" id="settig">
                2
            </div>
            <!-- porfile Summary -->
            <div class="tab-pane fade" id="porfile">
              3 
            </div>
           


        </div>
       
    </section>
    
    <app-footer></app-footer>
    
    <div class="modal fade" bsModal #deleteModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Delete all badla order</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeDeleteBadlaOrder()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete all badla?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" (click)="closeDeleteBadlaOrder()">Close</button>
                <button type="button" class="btn btn-success" (click)="deleteBadlaOrder()">Confirm</button>
            </div>
        </div>
    </div>
    </div>

    